import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeScreen from './pages/HomeScreen';
import ProductScreen from './pages/ProductScreen';
import CartScreen from './pages/CartScreen';
import LoginScreen from './pages/LoginScreen';
import RegisterScreen from './pages/RegisterScreen';
import ProfileScreen from './pages/ProfileScreen';
import FavoritesScreen from './pages/FavoritesScreen';
import OrderHistoryScreen from './pages/OrderHistoryScreen';
import OrderDetailsScreen from './pages/OrderDetailsScreen';
import CheckoutScreen from './pages/CheckoutScreen';
import Dashboard from './pages/admin/Dashboard';
import ProductListScreen from './pages/admin/ProductListScreen';
import CategoryListScreen from './pages/admin/CategoryListScreen';
import UserListScreen from './pages/admin/UserListScreen';
import OrderListScreen from './pages/admin/OrderListScreen';
import SettingsScreen from './pages/admin/SettingsScreen';
import CouponListScreen from './pages/admin/CouponListScreen';
import BillingScreen from './pages/admin/BillingScreen';
import POSScreen from './pages/admin/POSScreen';
import InvoiceScreen from './pages/InvoiceScreen';
import AdminRoute from './components/AdminRoute';
import AdminLayout from './components/AdminLayout';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<><Header /><main className="flex-grow"><HomeScreen /></main><Footer /></>} />
              <Route path="/product/:id" element={<><Header /><main className="flex-grow"><ProductScreen /></main><Footer /></>} />
              <Route path="/cart" element={<><Header /><main className="flex-grow"><CartScreen /></main><Footer /></>} />
              <Route path="/login" element={<><Header /><main className="flex-grow"><LoginScreen /></main><Footer /></>} />
              <Route path="/register" element={<><Header /><main className="flex-grow"><RegisterScreen /></main><Footer /></>} />

              {/* Protected User Routes */}
              <Route path="/profile" element={<><Header /><main className="flex-grow"><ProfileScreen /></main><Footer /></>} />
              <Route path="/favorites" element={<><Header /><main className="flex-grow"><FavoritesScreen /></main><Footer /></>} />
              <Route path="/orders" element={<><Header /><main className="flex-grow"><OrderHistoryScreen /></main><Footer /></>} />
              <Route path="/orders/:id" element={<><Header /><main className="flex-grow"><OrderDetailsScreen /></main><Footer /></>} />
              <Route path="/orders/:id/invoice" element={<InvoiceScreen />} />
              <Route path="/checkout" element={<><Header /><main className="flex-grow"><CheckoutScreen /></main><Footer /></>} />

              {/* Protected Admin Routes */}
              <Route path="/admin" element={<AdminRoute />}>
                <Route element={<AdminLayout />}>
                  <Route index element={<Navigate to="/admin/dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="pos" element={<POSScreen />} />
                  <Route path="productlist" element={<ProductListScreen />} />
                  <Route path="categorylist" element={<CategoryListScreen />} />
                  <Route path="userlist" element={<UserListScreen />} />
                  <Route path="orderlist" element={<OrderListScreen />} />
                  <Route path="coupons" element={<CouponListScreen />} />
                  <Route path="billing" element={<BillingScreen />} />
                  <Route path="settings" element={<SettingsScreen />} />
                </Route>
              </Route>

            </Routes>
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}


export default App;

